import * as React from 'react';
import { Location } from 'redux-little-router';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { RouteStyledLink } from '../StyledLink/StyledLink';

import './MinusPhraseLibraryGroupsCountCell.css';

export interface MinusPhraseLibraryGroupsCountCellProps {
    groupsCount: number;
    link?: Location;
}

export class MinusPhraseLibraryGroupsCountCell extends React.Component<MinusPhraseLibraryGroupsCountCellProps> {
    render() {
        const { groupsCount } = this.props;

        if (groupsCount === 0) {
            return '–';
        }

        return <div className={Bem.cls('minus-phrase-library-groups-count-cell')}>{this.getLink()}</div>;
    }

    private getLink = () => {
        const { link, groupsCount } = this.props;

        if (!link) {
            return groupsCount;
        }

        return (
            <RouteStyledLink href={link} cls={Bem.cls('minus-phrase-library-groups-count-cell', 'link')}>
                {groupsCount}
                <Shape2
                    hoverable={true}
                    cls={Bem.cls('minus-phrase-library-groups-count-cell', 'icon')}
                    width={15}
                    height={15}
                    icon={Shape2Icon.link2}
                />
            </RouteStyledLink>
        );
    };
}
